export const UserRoles = {
  Admin: 'Admin',
  User: 'User',
  Manager: 'Manager',
  // Add more roles as needed
} as const;
